import { createContext, useContext, type ReactNode } from 'react';
import type { CompanyInfo, CountryDto, IdTypeDto } from '../api/types';
import { setNumberLocale } from './components';

/** Empresa del usuario y su país (lo que cambia por jurisdicción: instituciones, impuestos, identificaciones). */
const CompanyContext = createContext<CompanyInfo | null>(null);

export function CompanyProvider({ value, children }: { value: CompanyInfo | null; children?: ReactNode }) {
  // Antes de pintar las pantallas: los montos se formatean según el país de la empresa.
  setNumberLocale(value?.country?.code);
  return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

export function useCompany(): CompanyInfo | null {
  return useContext(CompanyContext);
}

export function useCountry(): CountryDto | null {
  return useContext(CompanyContext)?.country ?? null;
}

/** Opciones de tipo de identificación del país; si el valor guardado no está en la lista se conserva como opción. */
export function idTypeOptions(types: IdTypeDto[] | undefined, current?: string | null) {
  const list = (types ?? []).map((t) => ({ value: t.code, label: t.name }));
  if (current && !list.some((o) => o.value === current)) list.push({ value: current, label: current });
  return list;
}
